(function () {
  function initInstagramSwiper(container) {
    const swiperEl = container.querySelector('.instagram-feed__swiper');
    if (!swiperEl || swiperEl._swiperInstance) return;

    const sectionEl = container.classList.contains('instagram-feed-section')
      ? container
      : container.querySelector('.instagram-feed-section');

    const sectionId = sectionEl?.dataset.sectionId;
    const configEl = sectionId
      ? document.getElementById('instagram-feed-config-' + sectionId)
      : null;

    let gridGap = 16;
    if (configEl) {
      try {
        const config = JSON.parse(configEl.textContent);
        gridGap = config.gridGap || 16;
      } catch (e) {}
    }

    const swiper = new Swiper(swiperEl, {
      slidesPerView: 2.5,
      spaceBetween: 20,
      loop: true,
      centeredSlides: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },
      speed: 500,
      breakpoints: {
        480: { slidesPerView: 3.5, spaceBetween: 20 },
        550: { slidesPerView: 4, spaceBetween: 20 },
        750: { slidesPerView: 4.5, spaceBetween: 20 },
        1200: { slidesPerView: 5, spaceBetween: gridGap },
        1400: { slidesPerView: 6, spaceBetween: gridGap },
      },
    });

    swiperEl._swiperInstance = swiper;
  }

  function init() {
    document.querySelectorAll('.instagram-feed-section').forEach(initInstagramSwiper);
  }

  document.addEventListener('DOMContentLoaded', init);

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target.querySelector('.instagram-feed-section')) {
        initInstagramSwiper(e.target);
      }
    });
  }
})();